import AdditionalTasksSidebarWidgetModule from './sidebar-widget.module'

export default AdditionalTasksSidebarWidgetModule
